<div class="pfms-payment-status-card card">
    <div class="">
        <div class="grid p-fluid mt-3">
            <div class="field col-12 md:col-6">
                <h5 style="color:rgb(97, 27, 27); font-size: '1.0rem'; font-weight: bold;" class="px-3">
                    {{'PFMS Payment Status'| translate}}</h5>
            </div>

            <div class="field col-12 md:col-6 justify-end">
                <div>
                    <p-fileUpload accept=".xlsx" #fileUpload [customUpload]="true"
                        (uploadHandler)="onUploadPFMSPaymentStatus($event, 'PFMSPaymentStatusData', fileUpload)"
                        name="myfile[]" mode="basic" [maxFileSize]="500000000"
                        chooseLabel="{{'Upload Excel' | translate}}" [auto]="true">
                    </p-fileUpload>
                    <a href="../../../../../../assets/smaple excel/Book_EPC_Payment.xlsx" target="_blank"
                        class="cursorPtr"
                        style="color:rgb(95, 172, 228); font-size: '0.8rem'; font-weight: bold; justify-content: end;">
                        Download Sample Excel</a>
                </div>
                <button *ngIf="pfmsPaymentStatusData?.length" pButton pRipple type="button" icon="pi pi-trash"
                    pTooltip="{{'DELETE_FILE' | translate}}" class="p-button-rounded p-button-danger p-button-text"
                    (click)="clearPFMSpaymentStatusData()"></button>
            </div>
        </div>

        <div *ngIf="pfmsPaymentStatusData.length > 0" class="dashboardTable" style="margin: 5px;">
            <p-table [value]="pfmsPaymentStatusData" [rows]="10" [paginator]="false" responsiveLayout="scroll"
                [rowHover]="true" [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="APP_ID">{{'APP_ID'| translate}}</th>
                        <th>{{'FARMER_NAME'| translate}}</th>
                        <th>{{'FATHERS_NAME'| translate}}</th>
                        <th>{{'MOBILE_NO'| translate}}</th>
                        <th>{{'CONTRACTOR_NAME'| translate}}</th>
                        <th>{{'OUTLET'| translate}}</th>
                        <th>{{'AGREEMENT_NO'| translate}}</th>
                        <th>{{'PROGRAMME_NAME'| translate}}</th>
                        <th>{{'TOTAL_AREA'| translate}}</th>
                        <th>{{'DISTRICT'| translate}}</th>
                        <th>{{'VILLAGE'| translate}}</th>
                        <th>{{'BLOCK'| translate}}</th>
                        <th>{{'XEN_RE_VER_REMARKS'| translate}}</th>
                        <th>{{'TOTAL_REC_AMOUNT'| translate}}</th>
                        <th>{{'85PER_OF_COST'| translate}}</th>
                        <th>{{'STATE_SHARE_AMOUNT'| translate}}</th>
                        <th>{{'CENTER_SHARE_AMOUNT'| translate}}</th>
                        <th>{{'TOP_UP'| translate}}</th>
                        <th>{{'STATUS'| translate}}</th>
                        <th>{{'REMARKS'| translate}}</th>
                        <th>{{'PFMS_PAYMENT_DATE'| translate}}</th>
                        <!-- <th>{{'CAO_REMARKS'| translate}}</th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-target let-rowIndex="rowIndex">
                    <tr>
                        <td>{{target.AppId}}</td>
                        <td>{{target.FarmerName}}</td>
                        <td>{{target.FatherName}}</td>
                        <td>{{target.MobileNo}}</td>
                        <td>{{target.ContractorName}}</td>
                        <td>{{target.Outlet}}</td>
                        <td>{{target.AgreementNo}}</td>
                        <td>{{target.ProgrammeName}}</td>
                        <td>{{target.TotalArea}}</td>
                        <td>{{target.District}}</td>
                        <td>{{target.Village}}</td>
                        <td>{{target.Block}}</td>
                        <td>{{target.XENReVerificationRemarks}}</td>
                        <td>{{target.TotalRecommendedAmount}}</td>
                        <td>{{target.CostOf85Per}}</td>
                        <td>{{target.StateShareAmount}}</td>
                        <td>{{target.CentreShareAmount}}</td>
                        <td>{{target.TopUp}}</td>
                        <td>{{target.Status}}</td>
                        <td>{{target.Remarks}}</td>
                        <td>{{target.PFMSPaymentDate}}</td>
                        <!-- <td>{{target.CAORemarks}}</td> -->
                        <!-- <td>
                            <button pButton pRipple type="button" icon="pi pi-times"
                                (click)="deletePFMSpaymentStatusData(rowIndex)"
                                class="p-button-rounded p-button-text p-button-danger"></button>
                        </td> -->
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div *ngIf="pfmsPaymentStatusData.length > 0" class="button-container-submit mt-3 submit-button-card">
            <button pButton pRipple (click)="onSubmitStatePhyTarDate()" label="{{'SUBMIT' | translate}}"
                class="p-button-success" style="width: 100px; height: 32px; align-items: center;">
            </button>
        </div>
    </div>
</div>

<div *ngIf="responseDate.length > 0">
    <div class="card dashboardTable">
        <p-table #exportDataResponse [value]="responseDate" [rows]="15" [paginator]="true" [globalFilterFields]="[
                'AppID',
                'TotalAmt',
                'Status',
                'Remarks',
                'Message',
                ]" responsiveLayout="scroll" [rowHover]="true"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" [loading]="loadingExportResponse">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{'EXPORT_DATA_RESPONSE'| translate}}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="exportDataResponse.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="AppID">{{'APP_ID'| translate}}</th>
                    <th pSortableColumn="TotalAmt">{{'AMOUNT'| translate}}</th>
                    <th pSortableColumn="Status">{{'STATUS'| translate}}</th>
                    <th pSortableColumn="Remarks">{{'REMARKS'| translate}}</th>
                    <th pSortableColumn="Message">{{'MESSAGE'| translate}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-responseData>
                <tr [ngStyle]="{'color': 'black', 'background-color': responseGridBackgroundColor(responseData)}">
                    <td>{{responseData.AppID}}</td>
                    <td>{{responseData.TotalAmt}}</td>
                    <td>{{responseData.Status}}</td>
                    <td>{{responseData.Remarks}}</td>
                    <td>{{responseData.Message}}</td>
                </tr>
            </ng-template>

        </p-table>
    </div>
</div>